var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","md":"6","justify":"center"}},[_c('span',{staticClass:"subtitle font-weight-bold"},[_vm._v(_vm._s(_vm.label))]),_c('div',{ref:"columnChart"})])}
var staticRenderFns = []

export { render, staticRenderFns }